module.exports = __webpack_public_path__ + "static/media/5_MTA - New York City.27fa3dee.jpg";